import React from 'react';
import { Route } from '@/navigation/Route';
import { EventCloseCsvScreen } from './screens';

export const EVENTS_CLOSE_CSV_ROUTES = {
  itself: '/financial/event-close-csv',
};

export const EventCloseCsvNavigation = (): JSX.Element => (
  <Route
    exact
    path={EVENTS_CLOSE_CSV_ROUTES.itself}
    component={EventCloseCsvScreen}
    isPrivateRoute
  />
);
